module.exports = __webpack_public_path__ + "ml.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ml.svg
// module id = 946
// module chunks = 0